import IconButton from "@material-ui/core/IconButton";
import { makeStyles, useTheme as useMuiTheme } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";
import ArrowLeft from "@material-ui/icons/ArrowLeft";
import ArrowRight from "@material-ui/icons/ArrowRight";
import useTheme from "@saleor/hooks/useTheme";
import classNames from "classnames";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    dark: {
      "& svg": {
        color: theme.palette.primary.main
      },
      "&$disabled": {
        "& svg": {
          color: fade(theme.palette.primary.main, 0.2)
        }
      },
      "&:focus, &:hover": {
        "& > span:first-of-type": {
          backgroundColor: fade(theme.palette.primary.main, 0.2)
        }
      }
    },
    disabled: {},
    iconButton: {
      "& > span:first-of-type": {
        backgroundColor: theme.palette.background.default,
        borderRadius: "100%",
        transition: theme.transitions.duration.standard + "ms"
      },
      "& svg": {
        border: `solid 1px #BDBDBD`,
        borderRadius: "50%"
      },
      "&:focus, &:hover": {
        "& > span:first-of-type": {
          backgroundColor: fade(theme.palette.primary.main, 0.2)
        },
        backgroundColor: "transparent"
      },
      padding: 6
    },
    root: {
      color: theme.palette.text.secondary,
      margin: theme.spacing(0),
      position: "sticky",
      right: theme.spacing(0)
    }
  }),
  { name: "DropOffTablePaginationActions" }
);

export interface DropOffTablePaginationActionsProps {
  backIconButtonProps?: any;
  className?: string;
  totalCount?: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  nextIconButtonProps?: any;
  onNextPage(event);
  onPreviousPage(event);
}

export const DropOffTablePaginationActions: React.FC<DropOffTablePaginationActionsProps> = props => {
  const {
    backIconButtonProps,
    className,
    hasNextPage,
    hasPreviousPage,
    nextIconButtonProps,
    totalCount,
    onNextPage,
    onPreviousPage,
    ...other
  } = props;
  const classes = useStyles(props);

  const { isDark } = useTheme();
  const { direction } = useMuiTheme();

  return (
    <div className={classNames(classes.root, className)} {...other}>
      {!!totalCount && `(Total number: ${totalCount})`}
      <IconButton
        id="dropOffPaginationBackBtn"
        className={classNames(classes.iconButton, {
          [classes.dark]: isDark,
          [classes.disabled]: !hasPreviousPage
        })}
        onClick={onPreviousPage}
        disabled={!hasPreviousPage}
        data-test="button-pagination-back"
        {...backIconButtonProps}
      >
        {direction === "rtl" ? <ArrowRight /> : <ArrowLeft />}
      </IconButton>
      <IconButton
        id="dropOffPaginationNextBtn"
        className={classNames(classes.iconButton, {
          [classes.dark]: isDark,
          [classes.disabled]: !hasNextPage
        })}
        onClick={onNextPage}
        disabled={!hasNextPage}
        data-test="button-pagination-next"
        {...nextIconButtonProps}
      >
        {direction === "rtl" ? <ArrowLeft /> : <ArrowRight />}
      </IconButton>
    </div>
  );
};

DropOffTablePaginationActions.displayName = "DropOffTablePaginationActions";
export default DropOffTablePaginationActions;
